module.exports = __webpack_public_path__ + "static/businness-card-1-54e727da477edd713cd902edbe092a0b.jpg";